const Routes = {
    home: '/',
    login: '/login',
    tablero: '/tablero',
    abms: '/abms',
    usuarios: '/abms/usuarios',
    tenants: '/abms/tenants',
    plataformas: '/abms/plataformas'
};

export default Routes;
